import {defineMessages} from 'react-intl';

export default defineMessages({
    description: {
        id: 'app.resetPassword.invalidToken.description',
        defaultMessage: 'The link for resetting password is either invalid or expired. If you want to send a new link follow to {link}'
    }
});
